<div class="d-flex flex-column flex-sm-row gap-2">
  <!-- Month selector with prev/next buttons -->
  <div class="d-flex border rounded">
    <button
      type="button"
      class="btn btn-sm bg-body-tertiary rounded-start"
      (click)="previousMonth()"
    >
      <i class="bi bi-chevron-compact-left"></i>
    </button>

    <select
      id="monthSelect"
      class="form-select form-select-sm border border-bottom-0 border-top-0 rounded-0"
      [value]="month()"
      (change)="onMonthChange($event)"
    >
      <!-- IF value is not set this way but like [value]="months.January" it breaks -->
      <option value="1" [disabled]="isMonthDisabled(1)">
        {{ MONTH_LABELS[Months.January] }}
      </option>
      <option value="2" [disabled]="isMonthDisabled(2)">
        {{ MONTH_LABELS[Months.February] }}
      </option>
      <option value="3" [disabled]="isMonthDisabled(3)">
        {{ MONTH_LABELS[Months.March] }}
      </option>
      <option value="4" [disabled]="isMonthDisabled(4)">
        {{ MONTH_LABELS[Months.April] }}
      </option>
      <option value="5" [disabled]="isMonthDisabled(5)">
        {{ MONTH_LABELS[Months.May] }}
      </option>
      <option value="6" [disabled]="isMonthDisabled(6)">
        {{ MONTH_LABELS[Months.June] }}
      </option>
      <option value="7" [disabled]="isMonthDisabled(7)">
        {{ MONTH_LABELS[Months.July] }}
      </option>
      <option value="8" [disabled]="isMonthDisabled(8)">
        {{ MONTH_LABELS[Months.August] }}
      </option>
      <option value="9" [disabled]="isMonthDisabled(9)">
        {{ MONTH_LABELS[Months.September] }}
      </option>
      <option value="10" [disabled]="isMonthDisabled(10)">
        {{ MONTH_LABELS[Months.October] }}
      </option>
      <option value="11" [disabled]="isMonthDisabled(11)">
        {{ MONTH_LABELS[Months.November] }}
      </option>
      <option value="12" [disabled]="isMonthDisabled(12)">
        {{ MONTH_LABELS[Months.December] }}
      </option>
    </select>

    <button type="button" class="btn btn-sm bg-body-tertiary rounded-end" (click)="nextMonth()">
      <i class="bi bi-chevron-compact-right"></i>
    </button>
  </div>

  <div class="d-flex flex-row gap-2">
    <input
      type="number"
      id="yearInput"
      class="form-control form-control-sm"
      [value]="year()"
      (input)="onYearChange($event)"
      i18n-placeholder="
        placeholder|Placeholder text for the year input field in the month-year
        selector@@yearPlaceholder"
      placeholder="Year"
      min="2026"
      max="9999"
    />
    <button
      type="button"
      class="btn btn-sm btn-secondary"
      (click)="goToPresent()"
      ngbTooltip="Go to current month"
      i18n-ngbTooltip="
        tooltip|Tooltip for the button to navigate to the current month@@goToCurrentMonth"
    >
      <i class="bi bi-calendar-week"></i>
    </button>
  </div>
</div>
